import React from 'react';
import PropTypes from 'prop-types';
import Text from '../text';
import styles from './create-change-indicated-component/create-change-indicated-component.styles'
import { StyleSheet } from 'react-native';

function getSign(value, withPlusSign) {
  const sign = Math.sign(value);

  if (sign === 0 || (sign > 0 && !withPlusSign)) {
    return '';
  }

  if (sign === -1) {
    return '-';
  }

  return '+';
}

function addCurrency(txt, currency, currencyDisplay) {
  if (currency && currencyDisplay === 'code') { // currency code always with space
    return txt.replace(new RegExp(`${currency}([^ ])`), `${currency} $1`);
  }

  return txt;
}

function formatCurrency(txt, props) {
  const { currency, value, currencyDisplay, withPlusSign } = props;
  const resultTxt = addCurrency(txt, currency, currencyDisplay);
  const sign = getSign(value, withPlusSign);

  if(sign==='-')
    return <span style={StyleSheet.flatten(styles.negativeStyling)}>&minus;{`${resultTxt}`.trim()}</span>
  
  return `${sign}${resultTxt}`.trim();
}

function addSignToFormattedValue(formattedValue, props) {
  const { value, withPlusSign } = props;
  const sign = getSign(value, withPlusSign);

  if(sign==='-')
    return <span style={StyleSheet.flatten(styles.negativeStyling)} aria-label={`minus ${formattedValue}`}>&minus;{`${formattedValue}`}</span>;

  return `${sign}${formattedValue}`;
}

function renderContent(formattedValue, props) {
  return (
    <Text {...props.renderProps}>
      {formattedValue}
    </Text>
  );
}

renderContent.propTypes = {
  renderProps: PropTypes.object,
};

function renderFormattedValue(formattedValue, props) {
  const formattedValueWithSign = addSignToFormattedValue(formattedValue, props);

  if (typeof props.children === 'function') {
    return props.children(formattedValueWithSign);
  }
  return renderContent(formattedValueWithSign, props);
}

export {
  formatCurrency, renderFormattedValue, addCurrency, addSignToFormattedValue, getSign
};
